module.exports = __webpack_public_path__ + "img/trading-pic3.a92721cd.png";